@defer (on viewport) {
<button class="lang-btn" (click)="currencyDialog = !currencyDialog">
  @if (isLoading) {
  <p-skeleton width="60px" height="25px" borderRadius="999px"></p-skeleton>
  } @else {
  <span class="fi fi-{{countryFlag ? countryFlag.toLowerCase() : ''}} fis"
    style="font-size: 28px; border-radius: 50%;"></span> <span>{{activeCurrency}}{{ selectedLang?.code ? ' / ' + selectedLang.code.toUpperCase() : '' }}</span>
  }
</button>
} @placeholder {
<p-skeleton width="70.88px" height="31.6px" borderRadius="999px" styleClass="m-0"></p-skeleton>
}


<app-modal title="Select your Language and Currency" [theme]="theme$()" [isOpen]="currencyDialog"
  (closed)="currencyDialog = false;">
  <div class="p-2">
    <form [formGroup]="regionForm">
      <!--  country -->
      <div class="form-group country mb-3">
        <!-- dropdown -->
        @if (countries?.length) {

        <app-dropdown [data]="countries" optionKey="name" valueKey="name" formControlName="country" [filter]="true" filterKey="name"
          [theme]="theme$()" width="auto" (selectedItemChange)="onCountrySelect($event)">
          <ng-template #selectedTemplate let-item>
            <div class="d-flex align-items-center justify-content-between w-100 flex-row-reverse gap-2 h-100">
              <span class="fi fi-{{ item?.code?.toLowerCase() }} fis"
                style="font-size: 40px; border-radius: 50%;"></span>
              <div class="d-flex align-items-center gap-3">
                <i style="font-size: 24px;" class="pi pi-map-marker"></i>
                <div style="font-size: 20px; font-weight: 500;">{{ item.name }}</div>
              </div>
            </div>
          </ng-template>
          <ng-template #itemTemplate let-country let-select="select" let-isSelected="isSelected">
            <div class="dropdown-item" [class.selected]="isSelected" (click)="select(country)">
              <span class="fi fi-{{ country?.code ? country.code.toLowerCase() : '' }} fis"
                style="font-size: 30px; border-radius: 50%;"></span>
              <span style="font-size: 18px; font-weight: 500;">{{ country.name }}</span>
            </div>
          </ng-template>
        </app-dropdown>
        }
        @if (!countries?.length) {
        <p-skeleton width="100%" height="60px" borderRadius="999px"></p-skeleton>
        }
      </div>
      <!--  Language -->
      <div class="form-group language mb-3">
        <!-- dropdown -->
        <app-dropdown [data]="languages" formControlName="language" optionKey="label" valueKey="code" width="auto"
          [theme]="theme$()" (selectedItemChange)="onLanguageSelect($event)">
          <ng-template #selectedTemplate let-item>
            <div class="d-flex align-items-center justify-content-between w-100 flex-row-reverse gap-2 h-100">
              <div class="d-flex align-items-center gap-3 w-100">
                <i style="font-size: 24px;" class="pi pi-language"></i>
                <div style="font-size: 18px; font-weight: 500;">{{ item.label }}</div>
              </div>
            </div>
          </ng-template>
          <ng-template #itemTemplate let-lang let-select="select" let-isSelected="isSelected">
            <div class="dropdown-item" [class.selected]="isSelected" (click)="select(lang)">
              <span>{{ lang.label }}</span>
            </div>
          </ng-template>
        </app-dropdown>
      </div>
      <!--  Currency -->
      <div class="form-group currency mb-4">
        <!-- dropdown -->
        <app-dropdown [data]="currencyList" optionKey="currency" valueKey="currency" formControlName="currency"
          placeholder="Select Currency" width="auto" [theme]="theme$()" (selectedItemChange)="onCurrencySelect($event)">
          <ng-template #selectedTemplate let-item>
            @if (selectedCurrency) {
            <div class="d-flex align-items-center justify-content-between flex-row-reverse gap-2 h-100 w-100">
              <!-- Icon of selected Currency -->
              <img [src]="selectedCurrency.icon" alt="{{ this.selectedCurrency.currency }} Currency Logo" width="30px"
                height="30px">
              <!-- Currency name and Currency Icon -->
              <div class="d-flex align-items-center gap-3">
                <i style="font-size: 24px;" class="pi pi-dollar"></i>
                <div style="font-size: 20px; font-weight: 500;">{{ this.selectedCurrency.currency }}</div>
              </div>
            </div>
            }
          </ng-template>
          <ng-template #itemTemplate let-currency let-select="select" let-isSelected="isSelected">
            <div class="dropdown-item d-flex align-items-center gap-3" [class.selected]="isSelected"
              (click)="select(currency)">
              <!-- currency icon -->
              <img [src]="currency.icon" alt="{{ currency.currency }} Currency Logo" width="30px" height="30px">
              <!-- currency name -->
              <div style="font-size: 18px; font-weight: 500;">{{ currency.currency }}</div>
            </div>
          </ng-template>
        </app-dropdown>
      </div>
      <!-- Save Button -->
      <button class="save-button" (click)="updateRegionalSettings()">Save Settings</button>
    </form>
  </div>

</app-modal>

<p-toast></p-toast>